// extracted by mini-css-extract-plugin
module.exports = {"scorecard_wrapper":"oxjfU","cricketlb":"ezDeP","scorecard_top":"tXQi8","placeholder":"XGBD1","header_top":"_3TJw","ads":"wyL7e","title":"sUIXc","hide_widget":"kdIZA"};